module.exports = __webpack_public_path__ + "images/category_lp/watch/omega_samples/sec02_2_sp_ad48b0430baa5cf5761350a7dfe729d6.jpg";